import type {
  ApplicationResourceArtifactApi,
  SystemPackageResourceArtifactApi,
} from '@ingenico/api-sdk-device-management-private';
import type { ControlFormProps } from '@ingenico/react-section-utils';
import type { IStepProps } from '@ingenico/react-ui/content-stepper';
import type { StepperApi } from '@ingenico/react-ui/stepper';
import type { MutableRefObject } from 'react';
import type { FieldPath, UseFormReturn } from 'react-hook-form';
import type { TFunction } from 'react-i18next';

import type {
  AppVersion,
  AppVersionApplicationFile,
} from '../../pages/applications-version-details-page/applicationVersionDetails.model';
import type { ApplicationVersionDefinitionWithOptions } from '../application-version-definition-step/applicationVersionDefinitionStep.model';

export interface ApplicationVersionDetailsStepsVMOutput {
  readonly formMethods: UseFormReturn<AppVersion>;
  readonly isLoading?: boolean;
  readonly stepperRef: MutableRefObject<StepperApi | null>;
  readonly steps: IStepProps[];
  readonly shouldShowConfirmationDialog: boolean;
  readonly isSendingAppVersion: boolean;
  readonly handleSendAppVersion: () => void;
  readonly t: TFunction;
  readonly handleCancelConfirmationDialog: () => void;
  readonly isLoadingCreation?: boolean;
  readonly hasPartialFileUpdateError?: boolean;
  readonly startSendingAppVersionFlow: () => void;
  readonly goToDeviceAppVersionsList: () => void;
}

export interface UseApplicationVersionDetailsStepsProps {
  readonly moveToNextStep?: (stepKey: AppVersionStepsKeys) => void;
  readonly moveToPreviousStep?: (stepKey?: AppVersionStepsKeys) => void;
  readonly control: ControlFormProps<AppVersion>['control'];
  readonly validateNextIsDisabled?: (stepKey?: AppVersionStepsKeys) => boolean;
  readonly applicationFiles?: AppVersionApplicationFile[];
  readonly existingTemplates?: AppVersionApplicationFile[];
  readonly setFieldError?: (fieldPath: FieldPath<AppVersion>, message: string) => void;
  readonly clearFieldError?: (fieldPath: FieldPath<AppVersion>) => void;
  readonly definitionOptions?: ApplicationVersionDefinitionWithOptions;
  readonly onClickCancel?: () => void;
  readonly hasPartialFileUpdateError?: boolean;
  readonly isLoadingTemplateResources?: boolean;
  readonly shouldEnableDownloadRules?: boolean;
  readonly triggerDeploymentRulesValidation?: () => void;
}
export interface UseApplicationVersionDetailsStepsReturn {
  readonly steps: IStepProps[];
}

export interface UseApplicationVersionDetailsStepsParams {
  readonly redirectRouteOnCreate?: string;
  readonly parentEntityId?: string;
  readonly t: TFunction;
}

export enum AppVersionStepsKeys {
  Define = 'define',
  Build = 'build',
  Configure = 'configure',
  Summary = 'summary',
  DeploymentRules = 'deploymentRules',
}

export type UploadedFileResponseInfo = {
  readonly targetLocation?: string;
  readonly uploadId?: string;
} & (ApplicationResourceArtifactApi | SystemPackageResourceArtifactApi);

export enum ApplicationVersionFormError {
  NoEmptyNamesInDeploymentRules = 'no-empty-names-in-deployment-rules',
}
